/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';

import {PersonOfInterestResponse} from '../models/person-of-interest';
import {Category} from "../models/category";
import {PaginationResult} from "@api/models/paginator";
import { PersonOfInterestCreate, PoiParams } from '@app/admin/person-of-interest/model/poi.model';


@Injectable({
  providedIn: 'root',
})
export class PersonOfInteresetApi extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  getPersonOfInterests(params: PoiParams){
    let body={}
    if(params) {
      body = {
        params: {
          'pageNumber': params.pageNumber || 0,
          'pageSize': params.pageSize || 10,
          'sortBy': params.sortBy || 'name',
          'sortDirection': params.sortDirection || 'asc',
          'customerIds': params.customerIds || [],
          'categories': params.categories || [],
          'text': params.text || '',
          'tags': params.tags || [],
          'dateFrom': params.dateFrom || '',
          'dateTo': params.dateTo || ''
        }
      }
    }
    return  this.http.get<PersonOfInterestResponse>(`${this.rootUrl}/personOfInterests/withpagination`, body)
  }


  uploadPoiImage(params: any, image: File){
    const form = new FormData();

    if (image) {
      form.append('Image', image, image.name);
    }

    if (params?.customerId != null) {
      form.append('CustomerId', String(params.customerId));
    }
    if (params?.name != null) {
      form.append('Name', params.name);
    }

    if (params?.categoryId != null) {
      form.append('CategoryId', String(params.categoryId));
    }

    if (Array.isArray(params?.tags)) {
      params.tags.forEach((tag: any, id: number) => {
        if (tag?.id != null) {
          form.append(`Tags[${id}].Id`, String(tag.id));
        }
        if (tag?.name != null) {
          form.append(`Tags[${id}].Name`, tag.name);
        }
      });
    }
    return this.http.post(`${this.rootUrl}/personOfInterests/create`, form);
  }

  createOrUpdatePersonOfInterest(poiId, poi) {
    return this.http.put(`${this.rootUrl}/personOfInterests/${poiId}`, poi )
  }

  deletePoi(poiIds){
    return this.http.delete(`${this.rootUrl}/personOfInterests`, {body: poiIds})
  }

  getCategories(params){
    let body={}
    if(params) {
      body = {
        params: {
          'pageNumber': params.pageNumber || 0,
          'pageSize': params.pageSize || 10,
          'sortBy': params.sortBy || 'name',
          'sortDirection': params.sortDirection || 'asc',
          'customerIds': params.customerIds || [],
        }
      }
    }

    return  this.http.get<PaginationResult<Category>>(`${this.rootUrl}/category`, body)
  }

  saveCategory(category :Category){
    return this.http.post(`${this.rootUrl}/category/${category.customerId}`, category)
  }

  updateCategory(category){
    return this.http.put(`${this.rootUrl}/category/${category.id}/${category.customerId}`, category)
  }

  deleteCategory(category: Category) {
    return this.http.delete(`${this.rootUrl}/category/${category.id}/${category.customerId}`)
  }


  getContactPerson(id){
    return  this.http.get(`${this.rootUrl}/contactPerson?customerId=${id}`)
  }

  getPersonOfInterest(id){
    return  this.http.get<PersonOfInterestCreate>(`${this.rootUrl}/personOfInterests/${id}`)
  }

  getCategoryDetails(categoryId:number, customerId:number){
    return this.http.get<Category>(`${this.rootUrl}/category/details/${categoryId}/${customerId}`)
  }
}

